var _sodipodiNamedview;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTheBoyCoding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "210mm",
    height: "297mm",
    viewBox: "0 0 210 297",
    id: "svg5",
    inkscapeVersion: "1.2.2 (732a01da63, 2022-12-09)",
    sodipodiDocname: "the_boy_coding.svg",
    xmlSpace: "preserve",
    xmlnSinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnSsodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnSsvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview7",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapeShowpageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#505050",
    "inkscapeDocument-units": "mm",
    showgrid: "false",
    inkscapeZoom: 2.0056913,
    inkscapeCx: 363.4657,
    inkscapeCy: 557.66308,
    inkscapeWindowWidth: 1920,
    inkscapeWindowHeight: 991,
    inkscapeWindowX: -9,
    inkscapeWindowY: -9,
    inkscapeWindowMaximized: 1,
    inkscapeCurrentLayer: "layer1"
  })), /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4298",
    inkscapeSwatch: "solid"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#08afff",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop4296"
  }))), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Layer 1",
    inkscapeGroupmode: "layer",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0.09,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers",
      stopColor: "#000000"
    },
    d: "m 51.769785,132.82914 c -0.929146,-3.56495 -1.301005,-7.38997 1.679022,-12.7792 3.06278,-3.46958 7.01107,-6.161 12.965765,-7.0892 1.763902,0.14707 3.41708,0.18341 5.596734,0.74623 0.06263,-1.17284 -0.3259,-2.15233 -1.492461,-2.79837 2.614562,-0.24384 3.383536,1.43482 3.917711,3.35805 3.625026,-0.86801 4.314605,0.5145 5.410177,1.58574 -1.142901,-0.39165 -1.996459,-0.30106 -2.611808,0.18655 4.703313,1.52973 6.107633,5.28851 7.648868,8.95478 0.259473,2.71043 1.558537,2.92584 -0.186557,10.44723 -0.0172,1.33985 0.30278,2.43126 -1.305904,4.94378 -1.764261,1.95674 -3.247673,1.66669 -4.757225,1.58575 -0.174398,0.92552 -0.102552,1.22849 -1.344541,3.63221 -6.424928,5.03306 -7.626141,4.77963 -11.248109,5.88223 -5.9699,0.23681 -8.03176,-1.02948 -10.727073,-2.05213 -4.405018,-4.15028 -2.101624,-6.17623 -1.585741,-8.76822 -0.427921,-2.67827 -0.899767,-5.35166 -0.559673,-8.11526 -0.658971,0.34363 -1.56762,1.01183 -1.399185,0.27983 z",
    id: "path4440",
    sodipodiNodetypes: "cccccccccccccccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0.09,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers",
      stopColor: "#000000"
    },
    d: "m 76.302133,145.98147 c 2.136892,1.86038 2.664153,2.08636 4.857807,4.00437 1.299745,1.13643 2.294056,3.22962 6.335661,5.88319 1.673753,-0.0229 3.304502,0.14765 5.316897,-1.39918 l 0.83951,0.65295 c 6.640472,-2.29484 12.812942,-1.1265 19.028892,-0.27984 0.36628,1.18153 0.54956,2.36307 0.65296,3.5446 1.11935,-0.16695 2.23869,-0.19014 3.35804,-0.0933 2.10432,-3.37498 5.1597,-5.87816 8.30182,-8.30182 1.14223,-0.75708 1.97213,-1.72844 2.52718,-2.65219 0.51473,-0.85665 1.34367,-1.19874 1.67037,-1.8252 0.8706,-0.33177 1.74121,-0.44898 2.61181,0.0933 11.78885,7.6998 6.34091,5.32274 8.3951,8.11527 -0.65454,0.43371 -1.44643,0.73008 -2.79837,0.46639 -2.50852,-1.16079 -5.18248,-2.60381 -6.24969,-1.3059 -3.82092,3.53398 -3.77953,5.3237 -5.13033,7.74214 1.76562,-1.45639 9.11991,-0.0429 13.80527,0 0.45375,-0.17695 0.95803,-0.17825 1.42313,-0.36958 1.53918,-0.63317 2.97755,-1.3783 3.52065,-0.74976 2.12668,1.5869 4.83558,2.96208 7.92871,4.19755 1.03532,1.65721 0.71253,2.67111 0.0933,3.54459 0.12488,0.21782 -1.06524,-0.003 -4.10427,-0.8395 -8.83325,0.30594 -17.98609,0.0526 -26.49121,0.93278 -0.80842,0.80408 -1.61683,1.30912 -2.42525,1.58575 -0.17155,0.47411 -4.75533,0.507 -7.27576,0.74623 -5.39889,0.0848 -10.5177,0.72967 -16.230521,0.18656 -4.353015,1.64204 -8.70603,1.77166 -13.059045,1.58574 -2.193045,-0.10861 -4.58963,-0.88201 -6.375944,-1.9212 -3.536481,0.93028 -7.381514,1.50792 -11.533604,1.73464 -2.096951,0.16057 -4.025503,0.79266 -6.529522,-0.18656 -5.816861,-3.12201 -1.880314,-5.19329 0.83951,-6.90264 -0.155465,-0.77055 -0.08008,-1.47284 -0.235542,-2.50722 l 1.914561,-3.08951 -0.361799,-0.43342 c 0.90589,-2.1875 2.001306,-4.375 3.346725,-6.5625 4.784985,0.0658 11.72556,-4.54092 12.032954,-5.59673 z",
    id: "path4444",
    sodipodiNodetypes: "cscccccccscccccccscccccccccccccccccc"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheBoyCoding);
export default __webpack_public_path__ + "static/media/the_boy_coding.9a1f77505e52ec5850f27e730a3c7ec0.svg";
export { ForwardRef as ReactComponent };